import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/primeng';
import { AcmType, AcmTypeOperation } from '../../../models/loyalty-acm-type.model';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { LoyaltyAcmTypeService } from '../../../services/loyalty/loyalty-acm-type.service';
import { Permission } from './../../../models/permission.model';
import { PermsService } from './../../../services/utils/perms.service';

@Component({
  selector: 'app-loyalty-acm-type',
  templateUrl: './loyalty-acm-type.component.html',
  styleUrls: ['./loyalty-acm-type.component.css']
})
export class LoyaltyAcmTypeComponent implements OnInit {

  columsTitles: any;
  totalRecords = 0;
  showModalDelete: boolean;
  translations: any;
  operationOptions: AcmTypeOperation;
  newDataAvailable = false;
  serverPagination = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  listOperations: Array<{label: string, value: string}>
  listAcmTypesFilter: Array<{label: string, value: string}>
  listAcmTypes: Array<{value: string, label: string}>;
  listStates: Array<{value: string, label: string}>;
  selectFilter = KontableComponent.SelectFilter;

  // Mostra tasti di edit, delete e recover
  acmTypePermission: Permission;

  constructor(
    private translate: TranslateService,
    public acmTypeService: LoyaltyAcmTypeService,
    private srvPermission: PermsService,
    private router: Router) {
  }

  ngOnInit() {
    this.loadPermissions();
    this.listAcmTypes = [];
    this.listStates = [];
    this.listAcmTypes.push({value: null, label: ''});
    this.listStates.push({ label: '', value: null });

    this.listOperations = [];
    this.listAcmTypesFilter = [];

    this.translate.get([
      'acm_type.acm_type_code',
      'acm_type.flg_operation',
      'acm_type.description',
      'acm_type.flg_operation_a',
      'acm_type.flg_operation_m',
      'acm_type.flg_operation_g',
      'acm_type.acm_typei_pid',
      'acm_type.acm_typeo_pid',
      'common.status_notDeleted',
      'common.status_onlyDeleted'
    ]).subscribe((translations) => {

      this.translations = translations;

      this.columsTitles = {
        acm_type_code: this.translations['acm_type.acm_type_code'],
        flg_operation: this.translations['acm_type.flg_operation'],
        description: this.translations['acm_type.description'],
        acm_typei_pid: this.translations['acm_type.acm_typei_pid'],
        acm_typeo_pid: this.translations['acm_type.acm_typeo_pid']
      };

      this.listOperations.push(
        { label: '', value: '' },
        { label: this.translations['acm_type.flg_operation_g'], value: 'G' },
        { label: this.translations['acm_type.flg_operation_m'], value: 'M' },
        { label: this.translations['acm_type.flg_operation_a'], value: 'A' }
      );

      this.acmTypeService.list().subscribe((res) => {
        for (const acmType of res.data) {
          this.listAcmTypesFilter.push({value: acmType.description, label: acmType.description});
          this.listAcmTypes.push({value: acmType.id, label: acmType.description});
        }
      });

      this.listStates.push({ label: this.translations['common.status_notDeleted'], value: '0' });
      this.listStates.push({ label: this.translations['common.status_onlyDeleted'], value: '1' });
    });

    this.operationOptions = new AcmTypeOperation(this.translate);

  }

  loadPermissions() {
    this.srvPermission.getPermission({ms_base: 'koncentro-loyalty', operation: 'acm'}).subscribe(res => {
      this.acmTypePermission = res;
    });
  }

  edit(param: AcmType) {
    this.router.navigate(['/loyalty/acm-type/form/' + param.id]);
  }

  addNew() {
    this.router.navigate(['/loyalty/acm-type/form/']);
  }

  remove(acmType) {
    this.showModalDelete = false;
    this.acmTypeService.remove(acmType.id).subscribe((res ) => {
      this.newDataAvailable = true;
    });
  }

  recover(acmType) {
    this.acmTypeService.recover(acmType).subscribe((res ) => {
      this.newDataAvailable = true;
    });
  }

  showOperation(row) {
    let operation;
    if (row.flg_operation.toUpperCase() === 'A') {
      operation = this.translations['acm_type.flg_operation_a'];
    } else if (row.flg_operation.toUpperCase() === 'M') {
      operation = this.translations['acm_type.flg_operation_m'];
    } else if (row.flg_operation.toUpperCase() === 'G') {
      operation = this.translations['acm_type.flg_operation_g'];
    }
    return operation;
  }

  showAcmTypei(row) {
    let Typei = '';
    if (!!row.acm_typei_pid) {
      this.listAcmTypes.forEach(acm => {
        if (acm.value === row.acm_typei_pid) {
          Typei = acm.label;
        }
      })
    }
    return Typei;
  }

  showAcmTypeo(row) {
    let Typeo = '';
    if (!!row.acm_typeo_pid) {
      this.listAcmTypes.forEach(acm => {
        if (acm.value === row.acm_typeo_pid) {
          Typeo = acm.label;
        }
      })
    }
    return Typeo;
  }

  getOperationList() {
    let emptylist: SelectItem[] = [{label: '', value: ''}];
    let oprionslist = this.operationOptions.getOptions();
    return emptylist.concat (oprionslist);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-acm-type/loyalty-acm-type.component.ts